export default __webpack_public_path__ + "static/media/real-waifu-w-pepe.1da402a7.jpeg";